import { modalAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const $bg = cssVar('modal-bg');
const $borderColor = cssVar('modal-border-color');
const $color = cssVar('modal-color');
const $overlayBg = cssVar('modal-overlay-bg');

const baseStyle = definePartsStyle(() => ({
  overlay: {
    bg: $overlayBg.reference,
    _dark: {
      [$overlayBg.variable]: 'colors.bg.overlay',
    },
  },
  dialogContainer: {
    // Container for centering the modal
  },
  dialog: {
    bg: $bg.reference,
    border: '1px solid',
    borderColor: $borderColor.reference,
    rounded: '2xl',
    color: $color.reference,
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    _dark: {
      [$bg.variable]: 'colors.bg.glass',
      [$borderColor.variable]: 'colors.border.strong',
      [$color.variable]: 'colors.fonts.primary',
      backdropFilter: 'auto',
      backdropBlur: 'xl',
    },
  },
  header: {
    color: $color.reference,
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
  closeButton: {
    // Close button styling - inherits from dialog color
  },
  body: {
    padding: 0,
    color: $color.reference,
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
  footer: {
    color: $color.reference,
    _dark: {
      [$color.variable]: 'colors.fonts.primary',
    },
  },
}));

export const modalTheme = defineMultiStyleConfig({
  baseStyle,
});
